import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { I18nProvider } from '@fiverr-private/fiverr_context';
import Switch from '@fiverr-private/fit/src/components/Switch';
import { FILTERS_LOCATION } from '../../../../../../../utils/constants';
import { FilterContext } from '../../../../../../context/filterContext';
import ToggleTooltip from './ToggleTooltip';
import './index.scss';

const Toggle = (props) => {
    const { title: baseTitle, text, educationContent, showNotification, params, tooltip, ...rest } = props;

    return (
        <I18nProvider>
            {({ i18n }) => {
                const title = i18n.t(baseTitle, params);

                if (!tooltip) {
                    return (
                        <ToggleSwitch title={title} {...rest}/>
                    );
                }

                return (
                    <ToggleTooltip id={props.id} title={title}
                        content={text && i18n.t(text, params)}
                        educationContent={educationContent && i18n.t(educationContent)}
                        showNotification={showNotification}>
                        <ToggleSwitch title={title} {...rest}/>
                    </ToggleTooltip>
                );
            }}
        </I18nProvider>
    );
};

class ToggleSwitch extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            toggled: props.options && props.options[0].selected
        };

        this.onChange = this.onChange.bind(this);
    }

    static contextType = FilterContext;

    onChange = ({ target }) => {
        const { selectedValue, position, id, onCustomChange, source }  = this.props;
        const newValue = { [id] : target.checked ? selectedValue : undefined };

        this.setState((prevState) => ({ ...prevState, toggled: !prevState.toggled }));

        if (onCustomChange){
            onCustomChange(newValue);
            return;
        }

        const { navigationCondition, applyNavigation, activeFilters } = this.context;

        if (navigationCondition(newValue, activeFilters)) {
            applyNavigation(newValue, activeFilters, position, source);
        }
    }

    render() {
        const { id, options, className, title } = this.props;
        const { selected } = options[0];

        return (
            <div className={classNames('toggler-wrapper', className)}>
                <Switch size={Switch.SIZES.SMALL} id={id} checked={this.state.toggled} value={selected}
                    onChange={this.onChange}/>
                {title}
            </div>
        );
    }
}

const ToggleSwitchPropTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    options: PropTypes.array,
    className: PropTypes.string
};

export const TogglePropTypes = {
    ...ToggleSwitchPropTypes,
    educationContent: PropTypes.string,
    text: PropTypes.string,
    showNotification: PropTypes.bool,
    position: PropTypes.string,
    tooltip: PropTypes.bool,
    onCustomChange: PropTypes.func
};

Toggle.propTypes = TogglePropTypes;
ToggleSwitch.propTypes = ToggleSwitchPropTypes;

Toggle.defaultProps = {
    checked: false,
    position: FILTERS_LOCATION.FLOATING_TOP,
    tooltip: false
};

export default Toggle;
